import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "@/pages/Dashboard";
import RecceDetail from "@/pages/RecceDetail";
import SharePage from "@/pages/SharePage";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Stats from "@/pages/Stats";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/auth";
import { ProtectedRoute } from "@/components/ProtectedRoute";

// Synchronously detect OAuth callback during render, before any other route resolves.
// useEffect would fire AFTER the first render — too late to win the race against
// AuthProvider's /auth/me check. See playbook §"Routing Structure (CRITICAL)".
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      {/* /share/:token is PUBLIC — anyone with the link can view, no sign-in needed */}
      <Route path="/share/:token" element={<SharePage />} />
      {/* / is PUBLIC — the AuthLock inside Dashboard handles unauthed users */}
      <Route path="/" element={<Dashboard />} />
      <Route
        path="/recce/:id"
        element={
          <ProtectedRoute>
            <RecceDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stats"
        element={
          <ProtectedRoute>
            <Stats />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
